<div class="title">
  <label>Load options</label>
</div>
<div class="work-space">
  <div class="fieldset">
    <div class="row">
      <label>Only the values specified below will be used from loaded content.</label>
    </div>
    <div class="col-12">
      <div class="form-check">
        <input (change)=UpdateCB($event.target) [attr.checked]="importGeneral" id="general_import_opt" class="form-check-input" type="checkbox" value="attributes" />
        <label class="form-check-label" for="general_import_opt">General - Project name and location</label>
      </div>
      <div class="form-check">
        <input (change)=UpdateCB($event.target) [attr.checked]="importAtts" id="attributes_import_opt" class="form-check-input" type="checkbox" value="attributes" />
        <label class="form-check-label" for="attributes_import_opt">Attributes - Point and Segment</label>
      </div>
      <div class="form-check">
        <input (change)=UpdateCB($event.target) [attr.checked]="importSupplemental" id="suppl_import_opt" class="form-check-input" type="checkbox" value="supplementals" />
        <label class="form-check-label" for="suppl_import_opt">Attributes - Supplemental Fields</label>
      </div>
      <div class="form-check">
        <input (change)=UpdateCB($event.target) [attr.checked]="importPresets" id="presets_import_opt" class="form-check-input" type="checkbox" value="presets" />
        <label class="form-check-label" for="presets_import_opt">Presets</label>
      </div>

    </div>
   </div>

</div>

<div class="footer full-width full-height centered">
  <label>Load From</label>

  <button (click)="LoadProject()" type="button" class="btn btn-sm btn-primary"><span class="icon fas fa-upload"></span>Server</button>
  <button type="button" class="btn btn-sm btn-primary" (click)="LoadContent()"><span
      class="icon fas fa-floppy-disk rot-180"></span>File</button>
  <button type="button" class="btn btn-sm btn-secondary" (click)="Hide()">Cancel</button>"
</div>
